import { render, staticRenderFns } from "./BulkAction.vue?vue&type=template&id=195ccb05&scoped=true&"
import script from "./BulkAction.vue?vue&type=script&lang=js&"
export * from "./BulkAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ccb05",
  null
  
)

export default component.exports